import axios from 'axios'
import Footer from 'components/footer'
import Navbar from 'components/navbar'
import domain from 'constants/domain'
import distance from 'utils/calculateDistance'
import { activities, terrains } from 'constants/placesTypes'
import setNearbyName from 'helpers/setNearbyName'
import Months from 'constants/Months'
import WeatherAndImages from 'constants/WeatherAndImages'
import { useState, useEffect, Fragment } from 'react'
import Weathers from '../../constants/Weathers'
import slugifyName from 'utils/slugifyName'
import Link from 'next/link'
import Head from 'next/head'
import _, { includes } from 'lodash'
import { getCleanedText, getStartCase } from 'utils/text'
import { marked } from 'marked'
import parse from 'html-react-parser'
import { handleClientScriptLoad } from 'next/script'

const options = {
  renderer: new marked.Renderer(),
}

options.renderer.paragraph = (text) => {
  return `<p class="md:text-base text-sm pb-2">${text}</p>`
}

options.renderer.list = (text, ordered) => {
  if (ordered) {
    return `<ul class="list-disc list-inside">${text}</ul>`
  } else {
    return `<ol class="list-decimal list-inside">${text}</ol>`
  }
}

options.renderer.listitem = (text) => {
  return `<li class="md:text-base text-sm pb-2">${text}</li>`
}

options.renderer.link = (href, title, text) => {
  return `<a href="${href}" target="_blank" class="text-blue-500">${text}</a>`
}

options.renderer.heading = (text, level) => {
  if (level === 3) {
    return `<h3 class="text-lg font-semibold mb-2">${text}</h3>`
  } else if (level === 4) {
    return `<h4 class="text-base font-semibold mb-2">${text}</h4>`
  } else {
    return ''
  }
}

options.renderer.hr = () => {
  return `<hr class="hidden" />`
}

const WeatherRender = (props) => {
  return (
    <Fragment>
      <div className="px-4 flex flex-row items-center justify-center">
        <div className="md:w-auto w-full">
          <div className="p-2 bg-skinColor rounded-xl">
            <div className="md:grid-cols-12 grid-cols-4 grid">
              {Months.map((month, index) => (
                <div key={index} className="grid-cols-1 grid ">
                  <div className="px-4 text-center w-full my-1">
                    <div className="p-1">{month.slice(0, 3)}</div>
                  </div>
                  <div className="my-1">
                    <div className="w-full">
                      <img
                        className="h-8 w-8 text-center m-auto my-1"
                        alt={props.CityName + ' KahanChale, Kahan Chale'}
                        src={'/images/Weathers/' + WeatherAndImages[props.Weather[month]].Image}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row items-center justify-center p-4">
        <div className="grid md:grid-cols-6 grid-cols-2 my-2 md:gap-0 gap-2">
          {Weathers.map((weather, index) => (
            <div key={index} className="flex flex-row items-left justify-left">
              <img className="float-left h-4 w-4 mx-2" src={'/images/Weathers/' + WeatherAndImages[weather].Image} />
              <span className="float-left text-xs">{weather}</span>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

const NearbyPlacesRender = (props) => {
  return (
    <div className="w-full">
      <div className="rounded-xl p-6 bg-skinColor">
        <h2 className="text-center mb-2 text-2xl font-semibold">Nearby Places</h2>
        <div className="grid grid-cols-1">
          {props.NearbyCities.map((city, i) => (
            <a target="_blank" className="cursor-pointer" key={i} href={`/city/${slugifyName(city.CityName)}`}>
              <div className="grid grid-cols-2 w-full gap-4 cursor-pointer">
                <div className="my-2 w-full">
                  <img className="w-60" src={city.Image} />
                </div>
                <div className="my-2 h-full">
                  <div className="flex flex-col w-full h-full items-center text-left justify-center">
                    <div className="py-1 w-full">
                      <h5 className="w-full text-left font-medium">{city.CityName}</h5>
                    </div>
                    <div className="py-1 w-full text-sm">
                      <h6>
                        Distance:{' '}
                        {distance(props.Location.Lat, props.Location.Long, city.Location.Lat, city.Location.Long)} km
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

const PlacesRender = (props) => {
  const arr = []
  const [arrLength, setArrLength] = useState(0)
  useEffect(() => {
    setArrLength(arr.length)
  }, [arr])

  const { showTitle = true } = props

  const printPlaces = (placeTypes, placeTypeCat, arr) => {
    return placeTypes.map((placeType, i) => {
      if (props.NearbyPlaces[placeTypeCat][placeType].applicable) {
        arr.push(i)
        return (
          <div key={i} className="md:px-0">
            <h5 className="text-black text-xl md:text-2xl font-semibold py-2">{setNearbyName(placeType)}</h5>
            {props.NearbyPlaces[placeTypeCat][placeType].places.map((place, i) => {
              return (
                <li className="md:text-base text-sm" key={i}>
                  {place.Name}
                </li>
              )
            })}
          </div>
        )
      }
    })
  }
  return (
    <div className="py-4 w-full">
      {showTitle && (
        <h2
          className={`text-black ${arrLength === 0 && 'hidden'} md:text-4xl text-3xl text-left font-semibold uppercase`}
        >
          Places of Interest
        </h2>
      )}
      <div className="grid sm:grid-cols-2 py-8 grid-cols-1 gap-6">
        {printPlaces(activities, 'Activity', arr)}
        {printPlaces(terrains, 'Terrain', arr)}
      </div>
    </div>
  )
}

const SingleCity = (props) => {
  // useEffect(() => {
  //   let refreshValue = 5
  //   let scrollingTimer
  //   let content
  //   let xVal = 100
  //   let scrollCheck = 21
  //   let numberOfMessagesSent = 1
  //   const maxMessages = 3
  //   let firstMessageTimer = 10000
  //   let messageIntervalCheck
  //   let firstMessageSent
  //   let subsequentMessageTimer = 7000
  //   let firstMessageIdleTimer
  //   let recheckTimer = 500
  //   let chatBotOpenCloseCheck = "close"
  //   let navBarElementHeight
  //   console.log(scrollCheck)
  //   const random = Math.random()
  //   const randomNumber = Math.floor(random * 9) + 1
  //   console.log(randomNumber)

  //   let userns

  //   async function order() {
  //     logM()
  //     checkConvToken()
  //     checkIframe()
  //     // checkFloatingText()
  //   }
  //   async function logM() {
  //     console.log('Starting the load of UCHAT Script')

  //     const script = document.createElement('script')
  //     script.async = true
  //     script.defer = true
  //     script.src = `https://www.uchat.com.au/js/widget/h0ey00a9hg9wjfyx/float.js?ref=blog--${randomNumber}`

  //     const head = document.getElementsByTagName('head')[0]
  //     head.appendChild(script)
  //   }

  //   async function checkIframe() {
  //     const iframeCheck = document.getElementById('chatbot_live_chat_widget')
  //     if (iframeCheck && xVal === 1298) {
  //       console.log('Before Retrieval Call')
  //       retrieveUUIDandUSERNS()
  //     } else {
  //       console.log('Waiting for Iframe to exist or Element not closed yet')
  //       setTimeout(checkIframe, 100)
  //     }
  //   }

  //   async function checkTarget() {
  //     const targetElement = document.querySelector('.bot-widget-bubble.bot-elements--right.bot-elements--right')
  //     const element = document.getElementById('chatbot_live_chat_widget')
  //     // const elements = document.getElementsByClassName("bot-widget-holder bot-elements--right bot-elements--right");
  //     if (targetElement) {
  //       setTimeout(() => {
  //         targetElement.click()
  //         element.style.visibility = "hidden"
  //         // elements[0].style.visibilty = "hidden"
  //         console.log('Element clicked')
  //         refreshValue = 6
  //       }, 1500)
  //     } else {
  //       console.log('Element not found! Waiting for it to exist')
  //       setTimeout(checkTarget, 100)
  //     }
  //   }
  //   //just a test

  //   async function checkClose() {
  //     const closeElement = document.querySelector(
  //       '.bot-elements--right.bot-elements--right.bot-widget-bubble.bot--close'
  //     )
  //     const element = document.getElementById('chatbot_live_chat_widget')

  //     if (closeElement && refreshValue === 6) {
  //       setTimeout(() => {
  //         closeElement.click()
  //         element.style.visibility = "visible"
  //         console.log('Element Closed')
  //         xVal = 1298
  //         console.log('Set xVal to 1298')
  //         setupMutationObserver();
  //       }, 500)
  //     } else {
  //       console.log('Close not found. Waiting for it to exist')
  //       setTimeout(checkClose, 100)
  //     }
  //   }

  //   function clickandClose() {
  //     console.log('uChat widget script has been loaded.')

  //     checkTarget()
  //     checkClose()
  //   }

  //   async function retrieveUUIDandUSERNS() {
  //     setTimeout(async () => {
  //       try {
  //         let url = await getDocumentFromID()
  //         console.log('URL: ' + url)
  //         let urlsrc = await updateUrl(url)
  //         let userdata = await sendUrl(urlsrc)
  //         console.log(userdata)
  //         userns = userdata.userdata.userns
  //         console.log('USERNS' + userns)
  //         scrollCheck = 23 //To make sure that scroll is not executed before all data is loaded. Initializes at 21. Checks at 23
  //       } catch (error) {
  //         console.error('Error while getting elements from URL:', error)
  //       }
  //     }, 2000)
  //   }

  //   async function getCookie(name) {
  //     const cookies = document.cookie.split(';')
  //     for (let i = 0; i < cookies.length; i++) {
  //       const cookie = cookies[i].trim()
  //       if (cookie.startsWith(name + '=')) {
  //         return cookie.substring(name.length + 1)
  //       }
  //     }
  //     return null
  //   }

  //   async function checkConvToken() {
  //     let newCookie = document.cookie
  //     const strToCheck = 'conv_token'

  //     if (newCookie.includes(strToCheck)) {
  //       console.log('Conv_Token found')
  //       clickandClose()
  //     } else {
  //       console.log('Conv_Token not found')
  //       setTimeout(checkConvToken, 500)
  //     }
  //   }

  //   order()

  //   function sendFirstMessage() {
  //     firstMessageIdleTimer = setTimeout(async function checkPElementsAndSend() {
  //       if (scrollCheck === 23 && messageIntervalCheck === "set" && chatBotOpenCloseCheck === "close") { //Add the first timer variable check

  //         try {
  //           content = await getVisibleParagraphs()
  //           console.log("OK")
  //         } catch (error) {
  //           console.error('Error while getting visible paragraphs:', error)
  //         }

  //         try {


  //           await postDataToAPI(content, userns)
  //           firstMessageSent = "sent"
  //           console.log(firstMessageSent)
  //           // window.removeEventListener('scroll', firstHandleScroll)
  //           window.addEventListener('scroll', subsequentMessageScroll)

  //         }
  //         catch {
  //           console.log('ERROR')
  //         }


  //       } else {
  //         clearTimeout(firstMessageIdleTimer)
  //         firstMessageIdleTimer = setTimeout(checkPElementsAndSend, recheckTimer)
  //       }

  //     }, recheckTimer) //Make it  a variable


  //   }

  //   // async function checkIfChatBotVisible () {
  //   //   const visibleElement = document.querySelector(".bot-widget-holder.bot-elements--right.bot-elements--right");
  //   //   const visibleElementStyle = window.getComputedStyle(visibleElement)

  //   //   if(visibleElementStyle.visibility === 'visible') {
  //   //     chatBotOpenCloseCheck = "open"
  //   //   }

  //   //   else {
  //   //     chatBotOpenCloseCheck = "close"
  //   //   }


  //   // }


  //   // Function to set up the MutationObserver
  //   function setupMutationObserver() {
  //     const visibleElement = document.querySelector(".bot-widget-holder.bot-elements--right.bot-elements--right");

  //     if (!visibleElement) {
  //       console.log("Element not found. Waiting and retrying...");
  //       setTimeout(setupMutationObserver, 500); // Retry after 1 second
  //       return;
  //     }

  //     const observer = new MutationObserver((mutationsList, observer) => {
  //       console.log(visibleElement)
  //       console.log(window.getComputedStyle(visibleElement))
  //       let impChecker = window.getComputedStyle(visibleElement).visibility;
  //       let shadow = window.getComputedStyle(visibleElement).boxShadow

  //       if (impChecker === 'visible') {
  //         if(shadow !== "none"){
  //         chatBotOpenCloseCheck = "open"
  //         console.log(chatBotOpenCloseCheck)
  //       }
  //       else {
  //         chatBotOpenCloseCheck = "close"
  //         console.log(chatBotOpenCloseCheck)
  //         // clearTimeout(firstMessageIdleTimer)
  //         clearTimeout(scrollingTimer)
  //       }
  //     }


  //       else {

  //         chatBotOpenCloseCheck = "close"
  //         console.log(chatBotOpenCloseCheck)
  //         // clearTimeout(firstMessageIdleTimer)
  //         clearTimeout(scrollingTimer)
  //       }

  //     });

  //     observer.observe(visibleElement, { attributes: true });
  //   }

  //   // Call the setup function to begin observing



  //   // To disconnect the observer when needed:
  //   // observer.disconnect();


  //   // function firstHandleScroll() {
  //   //   if (scrollingTimer) {
  //   //     clearTimeout(scrollingTimer)
  //   //   }
  //   //   scrollingTimer = setTimeout(async function checkPElementsAndSend() {
  //   //     if (scrollCheck === 23 && messageIntervalCheck === "set") { //Add the first timer variable check


  //   //       try {
  //   //         content = await getVisibleParagraphs()
  //   //       } catch (error) {
  //   //         console.error('Error while getting visible paragraphs:', error)
  //   //       }

  //   //       try {
  //   //         await postDataToAPI(content, userns)
  //   //         firstMessageSent = "sent"
  //   //         console.log(firstMessageSent)
  //   //         window.removeEventListener('scroll', firstHandleScroll)
  //   //         window.addEventListener('scroll', subsequentMessageScroll)

  //   //       } catch {
  //   //         console.log('ERROR')
  //   //       }

  //   //     } else {
  //   //       clearTimeout(scrollingTimer)
  //   //       scrollingTimer = setTimeout(checkPElementsAndSend, 500)
  //   //     }

  //   //   }, 500) //Make it  a variable
  //   // }

  //   function subsequentMessageScroll() {
  //     if (scrollingTimer) {
  //       clearTimeout(scrollingTimer)
  //     }
  //     if (numberOfMessagesSent < maxMessages) {
  //       scrollingTimer = setTimeout(async function checkPElementsAndSend() {
  //         if (firstMessageSent === "sent" && chatBotOpenCloseCheck === "close") { //Add the first timer variable check

  //           try {
  //             content = await getVisibleParagraphs()
  //           } catch (error) {
  //             console.error('Error while getting visible paragraphs:', error)
  //           }

  //           try {
  //             await postDataToAPI(content, userns)
  //             console.log("Subsequent Message Number: " + numberOfMessagesSent)
  //             numberOfMessagesSent = numberOfMessagesSent + 1
  //             if (numberOfMessagesSent === maxMessages) {
  //               window.removeEventListener('scroll', subsequentMessageScroll)
  //               console.log("Removed Event Listener")
  //             }
  //             // console.log(numberOfMessagesSent)
  //           } catch {
  //             console.log('ERROR')
  //           }
  //           //secondMessage()
  //         } else {
  //           clearTimeout(scrollingTimer)
  //           scrollingTimer = setTimeout(checkPElementsAndSend, recheckTimer)
  //         }

  //       }, subsequentMessageTimer)
  //     }
  //     // else {
  //     //   window.removeEventListener('scroll', subsequentMessageScroll)
  //     //   console.log("Removed Event Listener")
  //     // }
  //   }



  //   function setMessageInterval() {
  //     messageIntervalCheck = "set"
  //     sendFirstMessage()
  //     console.log(messageIntervalCheck)
  //   }

  //   function setVar() {
  //     setTimeout(setMessageInterval, firstMessageTimer)
  //   }

  //   function getNavBarHeight() {
  //     const navBarElement = document.getElementById('navbarTop')

  //     if (navBarElement) {
  //       navBarElementHeight = navBarElement.offsetHeight;
  //       console.log("MY HEIGHT",navBarElementHeight)
  //     }
  //   }

  //   function newCall() {
  //     setVar();
  //     getNavBarHeight();
  //   }

  //   // function setVarSubSequent () {
  //   //   setTimeout(setMessageInterval, 10000)
  //   // }

  //   //Number of messages variable
  //   //Scroll Timer
  //   //First timer - First message loading timer: After 10 sec, set a variable
  //   //Subsequent message timer - If 1st message sent, then check


  //   // window.addEventListener('scroll', firstHandleScroll)
  //   // window.addEventListener('', firstMessage)
  //   if (document.readyState === "complete") {
  //     newCall()
  //   } else {
  //     window.addEventListener('load', newCall);
  //     return () => document.removeEventListener('load', handler);
  //   }

  //   //API TO SEND DATA TO BACKEND

  //   async function sendUrl(src) {
  //     const url = 'https://blog-uchat-nudge.thechatman.ai:3001/getuserns?url=' + src
  //     try {
  //       const response = await fetch(url)
  //       const data = await response.json()
  //       return data
  //       // Handle the data or perform any necessary actions here
  //     } catch (error) {
  //       console.error('Error:', error)
  //       // Handle errors here
  //     }
  //   }

  //   async function postDataToAPI(data, userns) {
  //     const article = {
  //       content: data,
  //       userns: userns,
  //     }
  //     // Convert the article object to JSON string
  //     const jsonArticle = JSON.stringify(article)
  //     console.log(article)

  //     // Set the URL of the API endpoint
  //     const url = 'https://blog-uchat-nudge.thechatman.ai:3001/postapi'

  //     // Make the POST request
  //     fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: jsonArticle,
  //     })
  //       .then((response) => {
  //         if (response.ok) {
  //           console.log(response.json())
  //           console.log('Data posted successfully.')
  //         } else {
  //           console.log('Failed to post data. Status code:', response.status)
  //           console.log(body)
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error:', error)
  //       })
  //   }

  //   async function getVisibleParagraphs() {
  //     console.log('This works too')
  //     console.log('Navbar height:', navBarElementHeight)
  //     const containerDiv = document.querySelector('.flex.flex-col.items-start.justify-start.mt-4');
  //     const paragraphs = Array.from(containerDiv.querySelectorAll('h1, h2, h3, h4, h5, h6, strong'));

  //     let pageTop = 0 + navBarElementHeight
      
  //     let visibleParagraphs = '';
    
  //     for (let i = 0; i < paragraphs.length; i++) {
  //       const paragraph = paragraphs[i];
  //       const rect = paragraph.getBoundingClientRect();
    
  //       if (rect.bottom >= pageTop && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
  //         visibleParagraphs = visibleParagraphs + paragraph.outerHTML;
  //       }
  //     }
    
  //     const h1 = document.querySelector('h1');
  //     let newData = "####\n" + (h1 ? h1.innerText : '') + "\n####\n****\n" + visibleParagraphs +"\n****";
  //     return newData;
  //   }
    

  //   //FUNCTION TO GET IFRAME SRC
  //   async function getDocumentFromID() {
  //     const iframeElement = document.getElementById('chatbot_live_chat_widget')
  //     console.log(iframeElement.src)
  //     // var iFrameDoc = iframeElement.contentDocument || iframeElement.contentWindow.document;
  //     console.log(iframeElement)
  //     // console.log(iFrameDoc)
  //     return iframeElement.src
  //   }

  //   //FUNCTION TO GET UUID
  //   async function updateUrl(url) {
  //     let x
  //     console.log(url)
  //     const convToken = await getCookie('conv_token')
  //     let myCookie = 'conv_token=' + convToken
  //     const strToCheck = 'conv_token'

  //     if (url.includes(strToCheck)) {
  //       x = url
  //     } else {
  //       x = url + '&' + myCookie
  //     }

  //     console.log('UPDATED URL: ' + x)

  //     return x

  //   }

  //   return () => {
  //     clearTimeout(scrollingTimer)
  //     // window.removeEventListener('scroll', firstHandleScroll)
  //   }
  // }, [])

  return (
    <>
      {!props.newBlog ? (
        <Head>
          <title>Find More Information about {getStartCase(props.CityName)} - Kahan Chale</title>
          <meta name="title" content={`Find More Information about ${getStartCase(props.CityName)} - Kahan Chale`} />
          {/* <script src='https://blog-uchat-nudge.thechatman.ai:3000/chatbot'></script> */}
          <script async defer src="https://blog-uchat-nudge.thechatman.ai:3000/chatbot"></script>
        </Head>
      ) : (
        <Head>
          <title>
            {_.startCase(_.lowerCase(props.CityName))} Tourism {new Date().getFullYear()} Everything about{' '}
            {_.startCase(_.lowerCase(props.CityName))} | Kahan Chale
          </title>
          <meta
            name="title"
            content={`${_.startCase(
              _.lowerCase(props.CityName)
            )} Tourism ${new Date().getFullYear()} Everything about ${_.startCase(
              _.lowerCase(props.CityName)
            )} | Kahan Chale`}
          />

          <meta name="description" content={getCleanedText(props.newBlog.results.meta_description.answer)} />
          <meta name="og:image" content={props.Image} />
          <meta
            name="og:title"
            content={
              _.startCase(_.lowerCase(props.CityName)) +
              ' Tourism ' +
              new Date().getFullYear() +
              ' Everything about ' +
              _.startCase(_.lowerCase(props.CityName)) +
              ' | Kahan Chale'
            }
          />
          <meta name="og:description" content={getCleanedText(props.newBlog.results.meta_description.answer)} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={`${_.startCase(
              _.lowerCase(props.CityName)
            )} Tourism ${new Date().getFullYear()} Everything about ${_.startCase(
              _.lowerCase(props.CityName)
            )} | Kahan Chale`}
          />
          <meta name="twitter:description" content={getCleanedText(props.newBlog.results.meta_description.answer)} />
          <meta name="twitter:image" content={props.Image} />
          <meta name="og:type" content="blog" />
          <meta name="og:url" content={`https://kahanchale.com/city/${props.SlugifyName}`} />
          {/* <script src='https://blog-uchat-nudge.thechatman.ai:3001/plugin'></script> */}
          {/* <script src='http://localhost:3001/plugin'></script> */}
          {/* <script src='https://blog-uchat-nudge.thechatman.ai:3000/chatbot'></script> */}
          <script async defer src="https://chatengage-kahanchale.branceit.com:3001/plugin"></script>
        </Head>
      )}
      <Navbar isTransparentNav={false} />
      <div style={{ height: props.newBlog ? '50vh' : '70vh' }}>
        <div
          className="bg-no-repeat bg-center h-full bg-cover flex flex-col items-center justify-center"
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(${props.Image})`,
          }}
        >
          <h1 className="mt-10 md:text-6xl text-3xl font-semibold text-white tracking-wider">{props.CityName}</h1>
        </div>
      </div>
      {!props.newBlog && (
        <div className="pt-10 pb-5 md:px-12 px-4">
          <h2 className="text-black my-2 md:text-4xl text-3xl font-semibold uppercase">About {props.CityName}</h2>
          <div>
            <p>
              {props.FamilyFriendly && (
                <div className="text-themeOrange float-left md:text-base text-xs pr-4">#FamilyFriendly</div>
              )}
              {props.OffBeat && <div className="text-themeDarkBlue float-left md:text-base text-xs pr-4">#OffBeat</div>}
              {props.Activity.Shopping >= 9 && (
                <div className="text-themeGreen md:text-base text-xs">#ShoppersParadise</div>
              )}
            </p>
          </div>
          <br />
          <p className="my-2 md:text-base text-sm text-justify">{props.Description}</p>
        </div>
      )}
      {!props.newBlog && <WeatherRender CityName={props.CityName} Weather={props.Weather} />}

      {!props.newBlog && (
        <div className="pt-5 pb-10 md:px-12 px-4">
          <div className="grid gap-6 city-page-grid">
            <PlacesRender {...props} />
            <NearbyPlacesRender {...props} />
          </div>

          <div className="flex flex-row my-4 items-center justify-center">
            <a
              href={props.RLink}
              target="_blank"
              className="bg-themeOrange px-4 py-2 text-white float-left rounded-xl font-medium"
            >
              View More About {props.CityName}
              <img src="/images/new-page.png" className="float-right w-4 h-4 mt-0.5 ml-4" />
            </a>
          </div>
        </div>
      )}

      {props.newBlog && (
        <div className="grid md:grid-cols-70-30 grid-cols-1 md:px-16 px-4 gap-10">
          <div className="flex flex-col items-start justify-start mt-4">
            <div className="flex flex-row items-center justify-start">
              {props.FamilyFriendly && (
                <div className="text-themeOrange float-left md:text-base text-xs pr-4">#FamilyFriendly</div>
              )}
              {props.OffBeat && <div className="text-themeDarkBlue float-left md:text-base text-xs pr-4">#OffBeat</div>}
              {props.Activity.Shopping >= 9 && (
                <div className="text-themeGreen md:text-base text-xs">#ShoppersParadise</div>
              )}
            </div>
            <div className="mt-4">{parse(marked.parse(props.newBlog.results.introduction.answer, options))}</div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="best-time-to-visit">
              Table of Contents
            </h2>
            <div className="mt-4">
              <ul className="list-disc list-inside">
                <li>
                  <a href="#introduction" className="text-themeOrange">
                    Introduction
                  </a>
                </li>
                <li>
                  <a href="#history-and-culture" className="text-themeOrange">
                    History and Culture of {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#how-to-reach" className="text-themeOrange">
                    How to Reach and getting around {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#weather" className="text-themeOrange">
                    Weather of {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#places-to-visit" className="text-themeOrange">
                    Places to Visit in {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#food_options" className="text-themeOrange">
                    Food Options and Local Cuisine of {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#accommodation" className="text-themeOrange">
                    Best areas for Accommodation in {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#shopping" className="text-themeOrange">
                    Shopping in {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#nightlife" className="text-themeOrange">
                    Nightlife in {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#festivals_and_events" className="text-themeOrange">
                    Festivals and Events in {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#tips_for_travelers" className="text-themeOrange">
                    Tips for Travelers travelling to {getStartCase(props.CityName)}
                  </a>
                </li>
                <li>
                  <a href="#faqs" className="text-themeOrange">
                    FAQs
                  </a>
                </li>
              </ul>
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="history-and-culture">
              History and Culture of {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4">{parse(marked.parse(props.newBlog.results.history_and_culture.answer, options))}</div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="how-to-reach">
              How to Reach and getting around {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4">{parse(marked.parse(props.newBlog.results.how_to_reach.answer, options))}</div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10 mb-4" id="weather">
              Weather of {getStartCase(props.CityName)}
            </h2>
            <WeatherRender CityName={props.CityName} Weather={props.Weather} />
            <div className="mb-4">{parse(marked.parse(props.newBlog.results.weather.answer, options))}</div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="places-to-visit">
              Places to Visit in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 places-to-visit">
              {parse(
                marked.parse(
                  props.newBlog.results.places_to_visit.answer.replaceAll('.[', '.  [').replaceAll('] (', ']('),
                  options
                )
              )}
            </div>
            <div className="px-8 w-full -mt-12">
              <PlacesRender {...props} showTitle={false} />
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black" id="food_options">
              Food Options and Local Cuisine of {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 food_options">
              {parse(
                marked.parse(
                  props.newBlog.results.food_options.answer
                    .replace('About local cuisine:', '')
                    .replace('About Local Cuisine', ''),
                  options
                )
              )}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="accommodation">
              Best areas for accommodation in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 accommodation">
              {parse(marked.parse(props.newBlog.results.accommodation.answer, options))}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="shopping">
              Shopping in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 shopping">
              {parse(
                marked.parse(
                  props.newBlog.results.shopping.answer
                    .replace(`### Shopping at ${_.startCase(_.lowerCase(props.CityName))}`, '')
                    .replace(`### Shopping in ${_.startCase(_.lowerCase(props.CityName))}`, ''),
                  options
                )
              )}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="nightlife">
              Nightlife in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 nightlife">{parse(marked.parse(props.newBlog.results.nightlife.answer, options))}</div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="outdoor_activities">
              Outdoor Activities in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 outdoor_activities">
              {parse(marked.parse(props.newBlog.results.outdoor_activities.answer, options))}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="festivals_and_events">
              Festivals and Events in {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 festivals_and_events">
              {parse(marked.parse(props.newBlog.results.festivals_and_events.answer, options))}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="tips_for_travelers">
              Tips for Travelers while travelling to {getStartCase(props.CityName)}
            </h2>
            <div className="mt-4 tips_for_travelers">
              {parse(marked.parse(props.newBlog.results.tips_for_travelers.answer, options))}
            </div>
            <h2 className="text-3xl font-semibold md:text-left text-left text-black mt-10" id="faqs">
              FAQs
            </h2>
            <div className="mt-4 faqs md:mb-10">{parse(marked.parse(props.newBlog.results.faqs.answer, options))}</div>
          </div>
          <div className="flex flex-col items-center justify-center sticky top-0 overflow-y-scroll md:h-screen h-auto md:pt-52 hide-scrollbar mb-10">
            <div className="flex flex-col items-center justify-center bg-skinColor w-full p-4 rounded-md mb-4">
              <h2 className="text-2xl font-semibold text-black w-full">Discover Your Perfect Destination</h2>
              <p className="text-sm text-black font-light">
                Say hello to locations tailored to your interests discovered by AI.
              </p>
              <Link
                href="/quiz"
                className="float-left px-6 py-2 mt-4 inline-block text-sm bg-themeOrange rounded-xl text-white"
              >
                Find Perfect Getaway
              </Link>
            </div>

            <NearbyPlacesRender {...props} />
          </div>
        </div>
      )}

      <Footer />
    </>
  )
}

export default SingleCity

export const getStaticPaths = async () => {
  const cities = await axios
    .get(domain + 'get-names-of-cities')
    .then((res) => {
      return res.data.cities
    })
    .catch((err) => {
      console.log(err)
    })
  const cityNames = cities.map((city) => {
    return { params: { cityName: city.SlugifyName } }
  })
  return {
    paths: cityNames,
    fallback: false,
  }
}

export const getStaticProps = async ({ params }) => {
  const city = await axios
    .get(domain + 'get-single-city-details', {
      params: {
        SlugifyName: params.cityName,
      },
    })
    .then((res) => {
      return res.data.data
    })
  return {
    props: city,
  }
}
